// @flow strict
import type {OFFER_LETTER, JOB_INFORMATION} from 'src/types/crm';
import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {useHistory} from 'src/rerouter';

import {useApi} from 'src/hooks/useApi';

import {useDispatch, useSelector} from 'react-redux';
// $FlowFixMe[nonstrict-import]
import * as reduxApi from 'src/utils/redux-api-v2';

import {
  selectPendingOfferCandidateDetails,
  selectJobInformation,
} from 'src/selectors/crm';
import {
  SubTitleLarge,
  BodyMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {TabList, Tab} from '@spaced-out/ui-design-system/lib/components/Tabs';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';
import User from 'src/components/crm/lib/user/user.jsx';
// $FlowFixMe[untyped-import]
import {formatMomentDateAndTime} from 'src/utils/date-time';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';

import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@spaced-out/ui-design-system/lib/components/Modal';
import {
  Toast,
  TOAST_SEMANTIC,
  ToastTitle,
  toastApi,
} from '@spaced-out/ui-design-system/lib/components/Toast';
import {
  Panel,
  PanelBody,
  PanelHeader,
  PanelFooter,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';

import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {BasicDetails} from './tabs/basic-details.jsx';
import {CandidateResume} from './tabs/candidate-resume.jsx';
import {ApprovalStatus} from '../../approve-job/approve-job-form/tabs/approval-status.jsx';

import {UPDATE_SELECTED_PENDING_OFFER_CANDIDATE} from 'src/utils/crm.js';

import css from './approve-offer-form.css';
import {JobDetailsTab} from 'src/components/crm/lib/job-details-tab/job-details-tab.jsx';
import CandidateDetailsCard from 'src/components/crm/jobs/job-info/overview/feedbacks/panels/candidate-details-card/candidate-details.jsx';
import {
  getJobInformation,
  getApplicantInformation,
  getInterviewFlow,
  getJobScoreCards,
} from 'src/action-creators/crm';
import FeedbackAndScorecard from 'src/components/crm/applicants/body/tabComponents/feedback-and-scorecards/index.jsx';
import ApplicantAttachments from 'src/components/crm/applicants/body/tabComponents/attachments/index.jsx';
import CandidateFormsSubmitted from 'src/components/crm/applicants/body/tabComponents/forms/candidate-forms-submitted.jsx';
import {JobDescription} from 'src/components/crm/lib/job-description/job-description.jsx';


export const ApproveOfferForm = ({
  isOpen,
  handleClose,
  handleMoveBack,
  currentJobId,
  isRejected = false,
  isApproved = false,
  onSubmit,
}: {
  isOpen: boolean,
  handleClose: (queryObject?: {+[string]: string}) => void,
  handleMoveBack: (refetch: boolean) => void,
  currentJobId?: string,
  isRejected?: boolean,
  isApproved?: boolean,
  onSubmit?: () => void,
}): React.Node => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const selectedCandidate = useSelector(selectPendingOfferCandidateDetails);
  const [refetchApplicantData, setRefetchApplicantData] = React.useState(false);
  const history = useHistory();
  const {location} = history;
  const dispatch = useDispatch();
  const {candidateId, stageId} = selectedCandidate ?? {};
  const jobInfo = useSelector(selectJobInformation);

  const {parent} = location.query;
  const jobId = location.query.jobId || currentJobId || '';

  const fetchApplicantData = async () => {
    try {
      if (jobId) {
        await Promise.all([
          dispatch(getApplicantInformation(candidateId, jobId)),
          dispatch(getInterviewFlow(jobId.toString(), candidateId.toString())),
          dispatch(getJobScoreCards(Number(jobId))),
        ]);
      } else {
        await Promise.all([dispatch(getApplicantInformation(candidateId))]);
      }
    } finally {
    }
  };

  React.useEffect(() => {
    fetchApplicantData();
  }, [refetchApplicantData]);

  React.useEffect(() => {
    dispatch(getJobInformation(jobId));
  }, [jobId]);
  const [offerDetails, setOfferDetails] = React.useState<OFFER_LETTER | null>(
    null,
  );
  const [currentApprovalObject, setCurrentApprovalObject] =
    React.useState(null);
  const [selectedOption, setSelectedTabOption] = React.useState({
    label: t('Offer_Details', 'Offer Details'),
    tabId: 'offer',
  });
  const [actionModalState, setActionModalState] = React.useState<
    'approve' | 'reject' | null,
  >(null);
  const [offerApprovalMessage, setOfferApprovalMessage] = React.useState('');
  const [approvingOffer, setApprovingOffer] = React.useState(false);
  const [isLoadingData, setisLoadingData] = React.useState(false);
  const [candidateDetails, setCandidateDetails] = React.useState(null);
  const [jobDetails, setJobDetails] = React.useState<JOB_INFORMATION | null>(
    null,
  );
  const closePanelHandler = () => {
    handleClose();
  };

  const getTabComponent = () => {
    if (!offerDetails || !candidateDetails || !jobDetails) {
      return null;
    }
    if (selectedOption.tabId === 'offer') {
      return (
        <BasicDetails
          offerDetails={offerDetails}
          isApproved={isApproved}
          isRejected={isRejected}
          currentApprovalObject={currentApprovalObject}
        />
      );
    } else if (selectedOption.tabId === 'approvalStatus') {
      return (
        <ApprovalStatus
          approvalObject={offerDetails}
          approverStatusesList={offerDetails.approverStatuses}
        />
      );
    } else if (selectedOption.tabId === 'resume') {
      return (
        <CandidateResume
          candidateName={candidateDetails.name}
          resumeLink={candidateDetails.resumeLink}
        />
      );
    } else if (selectedOption.tabId === 'jobDetails') {
      return <JobDetailsTab jobDetails={jobInfo} />;
    } else if (selectedOption.tabId === 'jobDescription') {
      return <JobDescription jobInfo={jobInfo} hideExternalJD={true} />;
    } else if (selectedOption.tabId === 'candidate') {
      return <CandidateDetailsCard candidateId={candidateId} />;
    } else if (selectedOption.tabId === 'feedback') {
      return (
        <FeedbackAndScorecard
          jobId={Number(jobId)}
          applicantId={candidateId}
          reloadCandidateData={() =>
            setRefetchApplicantData(!refetchApplicantData)
          }
          hideDownloadButton={true}
        />
      );
    } else if (selectedOption.tabId === 'attachments') {
      return (
        <ApplicantAttachments
          jobId={Number(jobId)}
          applicantId={candidateId}
          hideAttachmentsApplicationSpecificAttachments={true}
          showActionButtons={false}
        />
      );
    } else if (selectedOption.tabId === 'form') {
      return (
        <CandidateFormsSubmitted
          jobId={Number(jobId)}
          candidateId={candidateId}
          reloadCandidateData={() =>
            setRefetchApplicantData(!refetchApplicantData)
          }
          showActionButtons={false}
        />
      );
    }

    return selectedOption.label;
  };

  const {result: candidateOffer, isLoading: candidateOfferPending} = useApi(
    `api/offer-letter?candidateId=${candidateId}&jobId=${jobId}&stageId=${stageId}`,
    {
      method: 'GET',
      shouldFetch: !!jobId && !!candidateId,
      deps: [jobId],
      apiPath: '/trmapi/',
    },
  );

  const {result: userDetails, isLoading: userDetailsLoading} = useApi(
    `api/get-user-profile`,
    {
      method: 'GET',
      shouldFetch: !!jobId,
      deps: [jobId],
      apiPath: '/trmapi/',
    },
  );

  React.useEffect(() => {
    if (candidateOffer && userDetails && candidateOffer.length) {
      const offer = candidateOffer[candidateOffer.length - 1];
      setOfferDetails(offer);
      console.log('offerrrr', offer, userDetails);
      setCurrentApprovalObject(
        offer.approverStatuses.find(
          (app) =>
            app.approverId === userDetails?.securityUserId &&
            app.approvalRequestId === offer.offerLetterApprovalRequest.id,
        ),
      );
    }
  }, [candidateOffer, userDetails]);

  console.log('currentApprovalObject', currentApprovalObject);

  const handleApproveOfferLetter = async (payload, messages) => {
    setApprovingOffer(true);
    await dispatch(
      reduxApi.post(
        `api/offer-letter-approval-statuses/${currentApprovalObject?.id ?? 0}`,
        payload,
        {},
        {apiPath: '/trmapi/'},
      ),
    )
      .then(() => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.success}>
            <ToastTitle>{messages.successMessage}</ToastTitle>
          </Toast>,
          {
            timeout: 2000,
          },
        );
        dispatch({
          type: UPDATE_SELECTED_PENDING_OFFER_CANDIDATE,
          payload: null,
        });
        if (onSubmit) {
          onSubmit();
        }
        handleClose({
          taskType: parent,
          jobId: jobId ? jobId.toString() : '',
          refetch: 'true',
        });
      })
      .catch(() => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>{messages.errorMessage}</ToastTitle>
          </Toast>,
          {
            timeout: 2000,
          },
        );
      })
      .finally(() => {
        setApprovingOffer(false);
      });
  };

  React.useEffect(() => {
    if (!selectedCandidate) {
      handleMoveBack(true);
    }
  }, [selectedCandidate]);

  React.useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        if (offerDetails && offerDetails.candidateId) {
          setisLoadingData(true);
          const [jobDetail, candidateDetail] = await Promise.all([
            dispatch(
              reduxApi.get(`api/jobs/${jobId}`, {}, {apiPath: `/trmapi/`}),
            ),
            dispatch(
              reduxApi.get(
                `api/candidates/${offerDetails.candidateId}?include=applications&populateJobId=0`,
                {},
                {apiPath: '/trmapi/'},
              ),
            ),
          ]);
          setJobDetails(jobDetail);
          setCandidateDetails(candidateDetail);
        }
      } catch (e) {
        throw e;
      } finally {
        setisLoadingData(false);
      }
    };

    fetchJobDetails();
  }, [offerDetails]);

  const renderFooter = () => {
    if (isRejected || isApproved) {
      return null;
    }

    return (
      <PanelFooter>
        <div className={css.row}>
          <Button
            classNames={{wrapper: css.rejectButton}}
            onClick={() => setActionModalState('reject')}
          >
            {t('Reject', 'Reject')}
          </Button>

          <Button onClick={() => setActionModalState('approve')}>
            {t('Approve', 'Approve')}
          </Button>
        </div>
      </PanelFooter>
    );
  };

  const renderStatusAlert = () => {
    if (isRejected) {
      return (
        // $FlowFixMe[incompatible-type]
        <InContextAlert leftIconName="shield-exclamation" semantic="danger">
          {t('Rejected_by', 'Rejected by')}:{' '}
          <User userId={parseInt(currentApprovalObject?.approverId, 10)} />
          {`, ${t('on', 'on')}`}{' '}
          {formatMomentDateAndTime(currentApprovalObject?.updatedOn)}
        </InContextAlert>
      );
    }

    if (isApproved) {
      return (
        // $FlowFixMe[incompatible-type]
        <InContextAlert leftIconName="circle-check" semantic="success">
          {t('Approved_by', 'Approved by')}:{' '}
          <User userId={parseInt(currentApprovalObject?.approverId, 10)} />
          {`, ${t('on', 'on')}`}{' '}
          {formatMomentDateAndTime(currentApprovalObject?.updatedOn)}
        </InContextAlert>
      );
    }

    return (
      <div className={css.taskRow}>
        <Icon name="info-circle" color="secondary" />
        <BodyMedium color="secondary">
          {offerDetails
            ? `${t(
                'Offer_Approval_requested_on',
                'Offer Approval requested on',
              )}: ${new Date(offerDetails.updatedOn).toLocaleString('en-US')}`
            : null}
        </BodyMedium>
      </div>
    );
  };

  return (
    <Panel
      anchor="right"
      isOpen={isOpen}
      onClose={() => handleMoveBack(false)}
      size="large"
      tapOutsideToClose
      hideBackdrop={false}
    >
      <PanelHeader onCloseButtonClick={closePanelHandler} size="medium">
        <SubTitleLarge>
          {isRejected || isApproved
            ? t('Review_Offer_Approval', 'Review Offer Approval')
            : `${t('Approve_Offer', 'Approve Offer')} ${
                selectedCandidate
                  ? `${t('for', 'for')} ${selectedCandidate.name}`
                  : ''
              }`}
        </SubTitleLarge>
      </PanelHeader>
      <PanelBody className={css.panelBody}>
        <div className={css.reviewWrapper}>
          {candidateOfferPending || userDetailsLoading || isLoadingData ? (
            <div className={css.loader}>
              <CircularLoader />
            </div>
          ) : (
            <>
              <div className={css.tabListWrapper}>
                <TabList
                  onSelect={setSelectedTabOption}
                  selectedTab={selectedOption}
                  size="medium"
                >
                  <Tab
                    label={t('Offer_Details', 'Offer Details')}
                    tabId="offer"
                  />
                  <Tab
                    label={t('Candidate_Details', 'Candidate Details')}
                    tabId="candidate"
                  />
                  <Tab label={t('Resume', 'Resume')} tabId="resume" />
                  <Tab
                    label={t('Feedback_Scorecard', 'Feedback & Scorecard')}
                    tabId="feedback"
                  />
                  <Tab
                    label={t('Job_Details', 'Job Details')}
                    tabId="jobDetails"
                  />
                  <Tab
                    label={t('Job_Description', 'Job Description')}
                    tabId="jobDescription"
                  />
                  <Tab label={t('Form', 'Form')} tabId="form" />
                  <Tab
                    label={t('Attachments', 'Attachments')}
                    tabId="attachments"
                  />
                  <Tab
                    label={t('Approval_Status', 'Approval Status')}
                    tabId="approvalStatus"
                  />
                </TabList>
              </div>
              {selectedOption.tabId === 'approvalStatus' && renderStatusAlert()}
              <div className={css.tabListComponent}>
                {offerDetails && userDetails ? getTabComponent() : null}
              </div>

              {actionModalState === 'approve' ? (
                <OfferApprovalCtaModal
                  title={t('Confirm_Approval', 'Confirm Approval')}
                  closeModal={() => {
                    setActionModalState(null);
                    setOfferApprovalMessage('');
                  }}
                  messageRequired={false}
                  message={offerApprovalMessage}
                  setMessage={setOfferApprovalMessage}
                  label={t('Add_comment_Optional', 'Add comment (Optional)')}
                  CtaButton={
                    <Button
                      onClick={() =>
                        handleApproveOfferLetter(
                          {
                            status: 'APPROVED',
                            comment: offerApprovalMessage,
                          },
                          {
                            successMessage: `${t(
                              'Offer_Approved_successfully',
                              'Offer Approved successfully',
                            )}!`,
                            errorMessage: `${t(
                              'Unable_to_approve_offer',
                              'Unable to approve offer',
                            )}`,
                          },
                        )
                      }
                      isLoading={approvingOffer}
                    >
                      {t('Approve', 'Approve')}
                    </Button>
                  }
                />
              ) : actionModalState === 'reject' ? (
                <OfferApprovalCtaModal
                  title={`${t('Reject_approval', 'Reject approval')}?`}
                  closeModal={() => {
                    setActionModalState(null);
                    setOfferApprovalMessage('');
                  }}
                  messageRequired={true}
                  message={offerApprovalMessage}
                  setMessage={setOfferApprovalMessage}
                  label={t('Add_Rejection_reason', 'Add Rejection reason')}
                  CtaButton={
                    <Button
                      classNames={{wrapper: css.rejectButton}}
                      onClick={() =>
                        handleApproveOfferLetter(
                          {
                            status: 'REJECTED',
                            comment: offerApprovalMessage,
                          },
                          {
                            successMessage: `${t(
                              'Offer_Rejected_successfully',
                              'Offer Rejected successfully',
                            )}!`,
                            errorMessage: `${t(
                              'Unable_to_reject_offer',
                              'Unable to reject offer',
                            )}`,
                          },
                        )
                      }
                      isLoading={approvingOffer}
                      disabled={!offerApprovalMessage}
                    >
                      {t('Reject', 'Reject')}
                    </Button>
                  }
                />
              ) : null}
            </>
          )}
        </div>
      </PanelBody>
      {renderFooter()}
    </Panel>
  );
};

const OfferApprovalCtaModal = ({
  title,
  closeModal,
  messageRequired,
  message,
  setMessage,
  CtaButton,
  label,
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <Modal
      initialFocus={1}
      onClose={closeModal}
      isOpen
      classNames={{content: css.modalContent}}
    >
      <ModalHeader onCloseButtonClick={closeModal}>
        <SubTitleLarge>{title}</SubTitleLarge>
      </ModalHeader>
      <ModalBody>
        <Textarea
          label={label}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required={messageRequired}
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal} type="ghost">
          {t('Close', 'Close')}
        </Button>
        {CtaButton}
      </ModalFooter>
    </Modal>
  );
};
